import { render, staticRenderFns } from "./CardBlog.vue?vue&type=template&id=57a09350&"
import script from "./CardBlog.vue?vue&type=script&lang=ts&"
export * from "./CardBlog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports